import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import Heading4 from 'app/components/v2/components/Text/Heading4';
import Link from 'app/components/v2/components/Text/Link';
import Paragraph from 'app/components/v2/components/Text/Paragraph';
import { externalUrls } from 'app/constants/externalUrls';

// Component Definition
const CookieContent: FC = () => {
  const { t } = useTranslation('components');

  return (
    <>
      <Heading4
        alignment="center"
        fontWeight="bold"
        marginBottom={4}
      >
        {t('interstitials.cookieContent.heading', 'Important Cookie Information')}
      </Heading4>

      <Paragraph>
        <Trans
          i18nKey="interstitials.cookieContent.alert"
          ns="components"
          t={t}
        >
          This site uses cookies to give you a great user experience. By using Triumph Payments, you agree to its
          {' '}
          <Link
            href={externalUrls.termsOfService}
            target="_blank"
          >
            Terms of Service
          </Link>
          {' '}
          and
          {' '}
          <Link
            href={externalUrls.privacyPolicy}
            target="_blank"
          >
            Privacy Policy.
          </Link>
        </Trans>
      </Paragraph>

      <Paragraph>
        {/* eslint-disable-next-line @stylistic/max-len */}
        {t('interstitials.cookieContent.allow', 'Allowing cookies is required to use this site. If you decline, a single cookie will be stored to remember your preference.')}
      </Paragraph>
    </>
  );
};

export default CookieContent;
